import { render, staticRenderFns } from "./blogtags.vue?vue&type=template&id=82fce09e&"
import script from "./blogtags.vue?vue&type=script&lang=js&"
export * from "./blogtags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82fce09e')) {
      api.createRecord('82fce09e', component.options)
    } else {
      api.reload('82fce09e', component.options)
    }
    module.hot.accept("./blogtags.vue?vue&type=template&id=82fce09e&", function () {
      api.rerender('82fce09e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22I4Ey5vyGV0W/JS/comp/blogtags.vue"
export default component.exports